import NotificationSetting from "./index.vue";
import Vue from "vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      isLoading: true,
      isProcessing: false
    };
  },
  computed: {
    notificationSetting() {
      return this.$store.state.domains.notificationSetting.notificationSetting;
    }
  },
  mounted() {
    this.getNotificationSetting();
  },
  methods: {
    async getNotificationSetting() {
      try {
        await this.$store.dispatch(
          "domains/notificationSetting/getNotificationSetting"
        );
      } catch (error) {
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
    async updateNotificationSetting(params) {
      try {
        this.isProcessing = true;
        await this.$store.dispatch(
          "domains/notificationSetting/updateNotificationSetting",
          {
            ...params
          }
        );
      } catch (error) {
        throw error;
      } finally {
        this.isProcessing = false;
      }
    }
  },
  render(createElement) {
    return createElement(NotificationSetting, {
      props: {
        notificationSetting: this.notificationSetting,
        isLoading: this.isLoading,
        isProcessing: this.isProcessing
      },
      on: {
        updateNotificationSetting: this.updateNotificationSetting
      }
    });
  }
});
